<template>
  <layout name="Builder">
    <div id="root" ref="reactRoot">
      <WithLoader :isLoading="builderIsLoading"></WithLoader>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";
import withNavigate from "@/mixins/withNavigate";
import { mapActions } from "vuex";
import WithLoader from "@/components/WithLoader";
import withToasted from "@/mixins/withToasted";

export default Vue.component("TemplateBuilder", {
  metaInfo: {
    title: "Template Builder"
  },

  data() {
    return {
      builderIsLoading: false,
      templateId: null,

      // getting manifest created by "Create React App" in builder
      builderManifest: require("../../public/lib/builder-src/asset-manifest")
    };
  },

  components: {
    Layout,
    WithLoader
  },

  mixins: [withNavigate, withToasted],

  mounted() {
    this.templateId = this.$route.params.id;
    if (this.identityLoaded && this.isAuthenticated) {
      this.builderIsLoading = true;

      // Creating script to load builder minified source
      const buildScript = document.createElement("script");
      buildScript.async = true;
      buildScript.setAttribute(
        "src",
        `lib/builder-src/${
          this.builderManifest["main.js"].split("/static/js/")[1]
        }`
      );

      // inject css from builder
      const buildCss = document.createElement("link");
      buildCss.setAttribute("rel", "stylesheet");
      buildCss.setAttribute(
        "href",
        `lib/builder-src/${
          this.builderManifest["main.css"].split("/static/css/")[1]
        }`
      );

      document.head.appendChild(buildCss);
      document.head.appendChild(buildScript);

      buildScript.onload = () => {
        try {
          this.unmountReact = window.__INKIT__.mountBuilder(
            document.getElementById("root"),
            {
              templateId: this.templateId
            }
          );
          this.builderIsLoading = false;
          this.setBuilderStatus(true);
        } catch (e) {
          this.toast(
            "Something went wrong. Try again later. If this stay still, please, contact support.",
            "error",
            {
              duration: 8000
            }
          );
        } finally {
          this.builderIsLoading = false;
        }
      };
    }
  },

  methods: {
    getBack() {
      this.$router.go(-1);
    },

    ...mapActions("service", ["setBuilderStatus"])
  },

  computed: {
    builderLoaded() {
      return this.$store.state.service.builderLoaded;
    },

    identityLoaded() {
      return this.$store.state.account.identityLoaded;
    },

    isAuthenticated() {
      return this.$store.state.auth.isAuthenticated;
    }
  },

  destroyed() {
    if (this.identityLoaded && this.unmountReact) {
      this.unmountReact();
    }
  }
});
</script>
